// @flow

import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Modal, ModalBody, Button, ModalHeader, ModalFooter } from 'reactstrap';

import { padSAtTheEndIfPlural } from '../../../lib/helpers';
import { useSelector } from '../../../redux/reduxDB';
import { getCartData } from '../../../redux/cart';
import config from '../../../config';

const mapStateToProps = ({ schema }, ownProps) => {
  const { lodgeId } = ownProps;
  const { name, bannerImages } = schema.lodgeDetail.byId[lodgeId];

  return {
    lodgeName: name,
    bannerImages: bannerImages || '',
  };
};

type Props = {
  isOpen: boolean,
  toggle: () => void,
  lodgeName: string,
  lodgeId: string,
  bannerImages: null | {
    medium: string,
  }
}

function CartUpdatedMessageModal(props: Props) {
  const { isOpen, toggle, lodgeName, bannerImages } = props;
  const [invoice, orderIds] = useSelector(getCartData);

  const { amount, currency } = invoice;
  const numOrders = orderIds.length;

  const imageUri = bannerImages ? `${config.RESOURCE_URL}/${bannerImages.medium}` : '';
  
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Successfully added to the Cart</ModalHeader>
      <ModalBody>
        <div className="cart-modal">
          <div className="lodge-wrap">
            <img src={imageUri} alt={lodgeName}/>
            <h4>{lodgeName}</h4>
          </div>
          <div className="cart-total">
            Cart Total({numOrders} {padSAtTheEndIfPlural(numOrders, 'Lodge')}):{' '}
            <span className="price">
              {currency} {amount.toLocaleString()}
            </span>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="mob">
        <Link to="/cart">
          <Button color="secondary" id="lodges-proceed-to-cart-btn">
            Proceed to Cart
          </Button>{' '}
        </Link>
        <Link to="/lodges">
          <Button color="yellow" id="lodges-keep-adding-lodges-btn">
            Keep Adding Lodges
          </Button>
        </Link>
      </ModalFooter>
    </Modal>
  );
}

export default connect(mapStateToProps)(CartUpdatedMessageModal);



// WEBPACK FOOTER //
// ./src/screens/Lodge/Details/CartUpdatedMessageModal.js